export class LocationGrid {
  constructor() {
    this.filterButtons = document.querySelectorAll(".location-filter-button");
    this.gridItems = [...document.querySelectorAll(".location-grid-item")];
    this.itemsToUse = [];
    this.itemsToNotUse = [];
    this.activeTab = document.querySelector(".filter_button_clicked");
    this.parentGrid = document.getElementById("expert-grid-parent");
    this.filterButtons.forEach(
      (button) => (button.onclick = this.filterButtonHandler.bind(this))
    );

    window.addEventListener("resize", this.handleResize.bind(this));
  }

  // Hide specific items
  hideItems(items) {
    items.forEach((item) => {
      item.classList.remove("see_location");
      item.classList.add("hide_location");
    });
  }

  // Get the computed style value for a given property of an element
  getComputedStyleValue(element, property) {
    return parseInt(
      window.getComputedStyle(element).getPropertyValue(property)
    );
  }

  // Calculate the grid size, number of columns, and grid height
  gridSizeAndColumnWidth(items) {
    this.locationGrid = document.querySelector(".location-grid");
    const gridWidth = this.locationGrid.offsetWidth;
    const referenceItem = items[0];
    const largestHeight = items.reduce(
      (max, item) => Math.max(max, item.offsetHeight),
      0
    );
    this.largestHeight = largestHeight;
    let largetHeightItem = items.reduce(
      (max, item) => (max.offsetHeight > item.offsetHeight ? max : item)
    );


    console.log("largestHeight", {
      largestHeight,
      largetHeightItem,
    
    });
    

    let marginTop = this.getComputedStyleValue(referenceItem, "margin-top");
    let marginBottom = this.getComputedStyleValue(
      referenceItem,
      "margin-bottom"
    );
    let marginY = marginTop > marginBottom ? marginTop : marginBottom;

    let marginLeft = this.getComputedStyleValue(referenceItem, "margin-left");
    let marginRight = this.getComputedStyleValue(referenceItem, "margin-right");
    let marginX = marginLeft > marginRight ? marginLeft : marginRight;

    let columnWidth = referenceItem.offsetWidth;
    let columns = Math.floor(gridWidth / columnWidth);

    let numRows = Math.ceil(items.length / columns);

    let gridHeight = numRows * ( largestHeight + marginY);

    return { columns, columnWidth, margin: marginY, gridHeight };
  }

  // Position the items on the grid, randomize their order
  placeItemsInCorrectPosition(items, columns, columnWidth, margin, gridHeight) {
    let random_items = items.sort(() => Math.random() - 0.5);

    random_items.forEach((item, index) => {
      let row = Math.floor(index / columns);
      let col = index % columns;

      let left = col * (columnWidth + margin);
      let top = row * ( this.largestHeight + margin);

      item.classList.remove("hide_location");
      item.classList.add("see_location");

      item.style.left = left + "px";
      item.style.top = top + "px";
      item.style.height = this.largestHeight + "px";
    });

    this.locationGrid = document.querySelector(".location-grid");
    this.locationGrid.style.height = gridHeight + "px";
    this.locationGrid.style.position = "relative";
  }

  // Initialize the grid with specific filters
  initGrid(keepSurgery = true) {
    // filter item with main
    this.initItems = this.gridItems.filter((item) => {
      let className = item.className;

      if (!keepSurgery) {
        //  if surgery is classname 
        return !className.includes("surgery") && item.dataset.service.match(/main|surgery/);
       }
      

      return  item.dataset.service.match(/main|surgery/);
    }
    );
    this.hideItems(
      this.gridItems.filter(
        (item) => !item.dataset.service.match(/main|surgery/)
      )
    );

    const { columns, columnWidth, margin, gridHeight } = this.gridSizeAndColumnWidth(this.initItems);
    this.placeItemsInCorrectPosition(
      this.initItems,
      columns,
      columnWidth,
      margin,
      gridHeight
    );
  }

  // Reset the grid to its original state (by calling initGrid)
  resetGrid(keepSurgery = true) {
    this.itemsToUse = this.gridItems; // reset to all items
    this.itemsToNotUse = [];
  
    this.hideItems(this.gridItems); // hide all items first
    this.initGrid(keepSurgery); // reinitialize the grid layout
  }

  // Filter handler when a filter button is clicked
  filterButtonHandler(e) {
    const identifier = e.target.id;
    this.activeTab && this.activeTab.classList.remove("filter_button_clicked");
    if (identifier == "all") {
      
      this.resetGrid();
      this.activeTab = e.target;
      e.target.classList.add("filter_button_clicked");

      return;
    }
    console.log({
      identifier,
    });
    

    if (identifier == "offices") { 
      this.resetGrid(false); // reset grid without surgery
      this.activeTab = e.target;
      e.target.classList.add("filter_button_clicked");
      return;
       
    }
    // reset grid if "all" filter is clicked



    this.itemsToUse = this.gridItems.filter((item) => item.dataset.service.match(identifier));
    this.itemsToNotUse = this.gridItems.filter(
      (item) => !item.dataset.service.match(identifier)
    );

    this.hideItems(this.itemsToNotUse);

    const { columns, columnWidth, margin, gridHeight } = this.gridSizeAndColumnWidth(this.itemsToUse);
    this.placeItemsInCorrectPosition(
      this.itemsToUse,
      columns,
      columnWidth,
      margin,
      gridHeight
    );

    this.activeTab = e.target;
    this.activeTab.classList.add("filter_button_clicked");
  }

  // Handle resizing of the window
  handleResize() {
    setTimeout(() => {
      if (this.itemsToUse.length > 0) {
        const { columns, columnWidth, margin, gridHeight } = this.gridSizeAndColumnWidth(this.itemsToUse);
        this.placeItemsInCorrectPosition(
          this.itemsToUse,
          columns,
          columnWidth,
          margin,
          gridHeight
        );
      }
    }, 500);
  }
}